import type { HostProps } from '../types';

/** 工厂 */
export function getHostProps(): HostProps {
    return (window.$wujie?.props || {}) as HostProps;
}
